import React, { memo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useDevice } from '@bonnet/next/device';

import { formatNumber } from '@atc/string-fns';

import { Pagination } from 'reaxl';

import vdpRatingReviewDuck from '@/ducks/vdp/vdpRatingReviewDuck.js';
import vdpReviewPaginationDuck from '@/ducks/vdp/vdpReviewPaginationDuck.js';

function ConsumerReviewPaginationComponent() {
    const dispatch = useDispatch();

    const { consumerRatings } = useSelector(vdpRatingReviewDuck.selectors.getDuckState);
    const { currentPage, numRecords } = useSelector(vdpReviewPaginationDuck.selectors.getDuckState);
    const device = useDevice();
    const notXS = device?.greaterThan?.xs || false;

    const handlePageSelect = (pageNumber) => {
        dispatch(vdpReviewPaginationDuck.creators.setCurrentPage(pageNumber));
        dispatch(vdpRatingReviewDuck.creators.setScrollToTopModal(true));
    };

    const styleNumber = (value) => (<span className="text-bold">{formatNumber({ value })}</span>);

    const renderReviewsCount = () => {
        let viewedResults = currentPage * numRecords;
        if (viewedResults > consumerRatings?.totalReviewCount) {
            viewedResults = consumerRatings?.totalReviewCount;
        }
        return (
            <div className="text-center">
                You have viewed
                {' '}
                {styleNumber(viewedResults)}
                {' '}
                of
                {' '}
                {styleNumber(consumerRatings?.totalReviewCount)}
                {' '}
                results
            </div>
        );
    };

    return (
        <>
            {renderReviewsCount()}
            <div
                className="display-flex justify-content-center align-items-center flex-wrap"
                data-cmp="cntnr-pagination"
            >
                <Pagination
                    activePage={currentPage}
                    items={Math.ceil((consumerRatings?.totalReviewCount ?? 0) / numRecords)}
                    onSelect={handlePageSelect}
                    maxButtons={notXS ? 10 : 7}
                    ellipsis={false}
                    version="v2"
                />
            </div>
        </>
    );
}

export const ConsumerReviewPagination = memo(ConsumerReviewPaginationComponent);

export default ConsumerReviewPagination;
